import React, { useState, useRef, useEffect } from "react";
import "./ImageGallery.css";

import pic01 from "../img/posters/daolu.jpg";
import vid01 from "../vid/daolu.webm";

import pic02 from "../img/posters/fengbao.jpg";
import vid02 from "../vid/fengbao.webm";

import pic03 from "../img/posters/ai.jpg";
import vid03 from "../vid/ai.webm";

import pic04 from "../img/posters/juedou.jpg";
import vid04 from "../vid/juedou.webm";

import pic05 from "../img/posters/laoshi.jpg";
import vid05 from "../vid/laoshi.webm";

import pic06 from "../img/posters/yinying.jpg";
import vid06 from "../vid/yinying.webm";

import pic07 from "../img/posters/yishujia.jpg";
import vid07 from "../vid/yishujia.webm";

const imageData = [
  {
    id: 1,
    imageUrl: pic01,
    videoUrl: vid01,
    title: "Dàolù - The Way",
    description:
      "The hero sets off towards the unknown, on the path of adventure, his heart filled with bravery, with the stars as his guide...",
    chapter: "Chapter 1",
  },
  {
    id: 2,
    imageUrl: pic02,
    videoUrl: vid02,
    title: "Fēngbào - The Storm",
    description:
      "The hero faces the elements, pursuing his quest in defiance of danger... No matter what the wind blows, he keeps going...",
    chapter: "Chapter 2",
  },
  {
    id: 3,
    imageUrl: pic03,
    videoUrl: vid03,
    title: "Ài - Love",
    description:
      "Despite the shattered mirrors, love will prevail in the end... And what would an adventure be without a love story?",
    chapter: "Chapter 3",
  },
  {
    id: 4,
    imageUrl: pic04,
    videoUrl: vid04,
    title: "Juédòu - Duel",
    description:
      "Each hero has his nemesis and it is by confronting him in a duel, in defiance of fear, that the hero can accomplish his quest...",
    chapter: "Chapter 4",
  },
  {
    id: 5,
    imageUrl: pic05,
    videoUrl: vid05,
    title: "Lǎoshī - Sensei",
    description:
      "A master is not the one who teaches something, but the one who pushes his student to give the best of himself in order to discover what he already knows",
    chapter: "Chapter 5",
  },
  {
    id: 6,
    imageUrl: pic06,
    videoUrl: vid06,
    title: "Yīnyǐng - Shadows",
    description:
      "Sheltered in the shadows, only the light offers her a hope of freedom... Every story has its hours of sadness.",
    chapter: "Chapter 6",
  },
  {
    id: 7,
    imageUrl: pic07,
    videoUrl: vid07,
    title: "Yìshùjiā - The Artist",
    description:
      "A hero which sacrafices his time and life to make others happy.",
    chapter: "Chapter 7",
  },
];

const ImageGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const videoRef = useRef(null);

  const handleImageClick = (imageId) => {
    const image = imageData.find((img) => img.id === imageId);
    setSelectedImage(image);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    // Optionally pause the video when closing the modal
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0; // Reset to the beginning
    }
  };

  useEffect(() => {
    if (selectedImage && videoRef.current) {
      videoRef.current.load(); // Load the new video source
      videoRef.current.play().catch((error) => {
        // Handle autoplay errors (browser policies)
        console.error("Autoplay prevented:", error);
        // Optionally display a play button
      });
    }
  }, [selectedImage]);

  return (
    <div className="ImageGallery section" id="about">
      <div className="container">
        <div className="image-grid">
          {imageData.map((image) => (
            <img
              key={image.id}
              src={image.imageUrl}
              alt={image.title}
              onClick={() => handleImageClick(image.id)}
              className="gallery-image"
            />
          ))}
        </div>

        {selectedImage && (
          <div className="modal">
            <div className="modal-content">
              <span className="close-button" onClick={handleCloseModal}>
                &times;
              </span>
              <div className="video-container">
                <video ref={videoRef} controls autoPlay playsInline>
                  <source src={selectedImage.videoUrl} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <h5>{selectedImage.chapter}</h5>
              <h2>{selectedImage.title}</h2>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageGallery;
